// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import qs from 'qs'
// import constyjyp from './httpurl/constyjyp.js';
// import axios from 'axios'
import ElementUI from 'element-ui';
import { apis } from "./core/apis";
import axios from 'axios'
import VueAxios from 'vue-axios'
import "./core/interceptors";
import 'element-ui/lib/theme-chalk/index.css';
import * as appUtils from "./core/appUtils";
import {constyjyp} from './core/constyjyp';
// import cryptoMd5 from 'crypto-md5';
// import Print from 'vue-print-nb';
import Print from '@/plugs/print';
import 'babel-polyfill';
import './assets/css/theme.css'
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(Print);


Vue.config.productionTip = false;

Vue.prototype.apis = apis.api;
Vue.prototype.constApi = apis;
Vue.prototype.appUtils = appUtils;
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.prototype.constyjyp = constyjyp;

console.log('process.env.NODE_ENV========='+process.env.NODE_ENV);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js